export const roundTo = (value: number, decimals = 1): number =>
    parseFloat(value.toFixed(decimals));
